import React from 'react';
import { AccordionSection } from '../AccordionSection';
import { BonusRewardsList } from './components/BonusRewardsList';
import { useActiveMemberRewards } from '~/shared/hooks/loyalty';

type BonusRewardsProps = {
    title: string;
    titleAddon?: number | string;
};

export const BonusRewardsSection = ({ title, titleAddon }: BonusRewardsProps) => {
    const { data: memberRewards } = useActiveMemberRewards({
        select: (rewards) =>
            rewards.value.map((reward) => ({
                status: reward.status,
                value: reward.value,
                lastvaliddate: reward.lastvaliddate,
                couponNo: reward.couponNo,
                barcode: reward.barcode,
            })),
    });

    return (
        <div style={{ borderBottom: '1px solid black' }}>
            <AccordionSection
                initOpenForSEO
                id="bonusrewards"
                title={title}
                titleAddon={titleAddon}
            >
                {memberRewards && <BonusRewardsList memberRewards={memberRewards} />}
            </AccordionSection>
        </div>
    );
};
